import { BaseEntity } from '../core/entities/base.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { RelationRef } from '../core/types/entity-types';
import { SubjectEntity } from '../subject/subject.entity';
import { ConsumerEntity } from '../consumer/consumer.entity';

export class EditorEntity extends BaseEntity {
  email!: string;
  password!: string;
  role!: string;
  subjects!: string[];
  consumerIds!: string[];

  updated?: Date;
  version?: number;

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjectsRel?: RelationRef<SubjectEntity>[];
}
